import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import ToastPlugin from 'vue-toast-notification';
import * as Sentry from "@sentry/vue";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import { faArrowLeft, faBars, faCow, faCreditCard, faDrumstickBite, faEnvelope, faFishFins, faHome, faIceCream, faLeaf, faPiggyBank, faQrcode, faRightFromBracket, faUtensils, faKeyboard, faK, faCartShopping, faPersonWalkingDashedLineArrowRight, faArrowsRotate, faAddressCard, faXmark, faFileContract, faKey, faTriangleExclamation, faUser } from '@fortawesome/free-solid-svg-icons';

library.add(faHome, faBars, faArrowLeft, faRightFromBracket, faCreditCard, faEnvelope, faLeaf, faQrcode, faPiggyBank, faCow,faFishFins,faUtensils, faDrumstickBite, faIceCream, faKeyboard, faCartShopping, faPersonWalkingDashedLineArrowRight, faArrowsRotate, faAddressCard, faXmark, faFileContract, faKey, faTriangleExclamation, faUser);
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import tr from './locales/tr.json';

const i18n = createI18n({
  legacy: false,
  locale: 'de', // default language is German
  fallbackLocale: 'de',
  missingWarn: false,
  fallbackWarn: false,
  missing: (locale, key) => {
    // Return the key itself (German text) when translation is missing
    return key;
  },
  messages: {
    en,
    tr,
  },
});

// Override the global $t function to handle variable interpolation for German text
const originalT = i18n.global.t;
i18n.global.t = function(key, values, options) {
  // First try the original translation
  const result = originalT.call(this, key, values, options);
  
  // If the result is the same as the key (meaning no translation was found)
  // and we have values to interpolate, do the replacement manually
  if (result === key && values && typeof values === 'object') {
    let interpolated = key;
    Object.keys(values).forEach(varKey => {
      const placeholder = `{${varKey}}`;
      interpolated = interpolated.replace(new RegExp(placeholder, 'g'), values[varKey]);
    });
    return interpolated;
  }
  
  return result;
};

let app = createApp(App);
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
    app,
    dsn: "https://dc0388af2f9c1b0f45fe74c61f5ac444@o4509549361954816.ingest.de.sentry.io/4509554275254352",
    integrations: [Sentry.browserTracingIntegration({router})],
    tracesSampleRate: 1.0, // Adjust for production
    autoSessionTracking: true, // Explicit for clarity
    release: `mein@${process.env.VUE_APP_VERSION}`,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}
app.config.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

app.component("font-awesome-icon", FontAwesomeIcon)
  .use(router)
  .use(ToastPlugin)
  .use(i18n)
  .mount("#app");// main.js
